"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fromLoginCredentials = void 0;
const credential_provider_login_1 = require("@aws-sdk/credential-provider-login");
const fromLoginCredentials = (init) => (0, credential_provider_login_1.fromLoginCredentials)({
    ...init,
});
exports.fromLoginCredentials = fromLoginCredentials;
